/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////
<template>
  <div v-if="showLazyLoader" class="simplepharm-modal">
    <div class="simplepharm-modal-content progress-modal-content">
      <div class="progress-modal-header">
        <h5 class="mb-0">Trwa wykonywanie zadania</h5>

        <button
            v-if="displayProgressBar"
            type="button"
            class="progress-close-btn"
            @click="closeProgressModal"
            aria-label="Zamknij"
        >
          ×
        </button>
      </div>
      <div class="progress-modal-body">
        <div v-if="!lazyloaderModule.getProcessErrorMessage" class="mb-2">
          {{ lazyloaderModule.getProgressBarMessage }}
        </div>
        <div v-else class="mb-2"></div>

        <div v-if="displayProgressBar" style="width: 100%;">
          <b-progress
              :value="progressBarProgress"
              :max="100"
              class="mb-2"
              variant="info"
              :animated="!isTerminal"
          ></b-progress>

          <div class="progress-meta-row">
            <span>{{ progressPercentage }}</span>
            <span v-if="currentStatusLabel">{{ currentStatusLabel }}</span>
          </div>

          <div
              v-if="lazyloaderModule.getProcessErrorMessage"
              class="task-error-box mt-3"
          >
            <strong>Błąd:</strong>
            <textarea
                class="task-error-textarea"
                :value="lazyloaderModule.getProcessErrorMessage"
                readonly
            ></textarea>
          </div>

        </div>

        <div v-else class="text-center">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "CommonProgressBarComponent",
  data() {
    return {
      showLazyLoader: false,
    };
  },
  computed: {
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    displayLazyLoader() {
      return this.lazyloaderModule.getDisplayLazyLoader;
    },
    displayProgressBar() {
      return this.lazyloaderModule.getDisplayProgressBar;
    },
    progressBarProgress() {
      return this.lazyloaderModule.getProgressBarProgress;
    },
    progressPercentage() {
      return `${Math.round(this.progressBarProgress)}%`;
    },
    isTerminal() {
      const status = this.lazyloaderModule.getProcessStatus;
      return status === "DONE" || status === "FAILED";
    },
    currentStatusLabel() {
      const status = this.lazyloaderModule.getProcessStatus;

      if (!status) {
        return "";
      }

      const labels = {
        NEW: "Nowe",
        QUEUED: "W kolejce",
        RUNNING: "W trakcie",
        DONE: "Zakończono",
        FAILED: "Błąd",
      };

      return labels[status] || status;
    },
  },
  watch: {
    displayLazyLoader: {
      handler(newVal) {
        this.showLazyLoader = !!newVal;
      },
      immediate: true,
    },
  },
  methods: {
    closeProgressModal() {
      this.lazyloaderModule.closeProgressBar();
    },
  },
};
</script>

<style scoped>
.progress-modal-content {
  width: 550px;
  max-width: calc(100vw - 40px);
}

.progress-modal-header,
.progress-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.progress-modal-body {
  margin-top: 12px;
}

.progress-meta-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.95rem;
}

.task-error-box {
  background: #fff3f3;
  border: 1px solid #f0b9b9;
  border-radius: 6px;
  padding: 10px 12px;
  color: #7a1f1f;
}

.task-id-box {
  background: #f8f9fa;
  border: 1px solid #d9dfe5;
  border-radius: 6px;
  padding: 10px 12px;
  word-break: break-word;
}

.progress-close-btn {
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  font-size: 1.4rem;
  line-height: 1;
  color: #6c757d;
  cursor: pointer;
  transition: color 0.15s ease;
}

.progress-close-btn:hover {
  color: #212529;
}

.task-error-textarea {
  width: 100%;
  min-height: 120px;
  max-height: 220px;
  resize: none;
  overflow-y: auto;
  border: 1px solid #dc3545;
  border-radius: 6px;
  background-color: #fff5f5;
  color: #842029;
  padding: 0.75rem;
  margin-top: 0.5rem;
  font-size: 0.9rem;
  line-height: 1.4;
}

.task-error-box {
  display: flex;
  flex-direction: column;
}

.task-error-textarea {
  white-space: pre-wrap;
}
</style>